module.exports = "pegasus/assets/blocks/column-lp8-themelp1.png";